<template>
    <div>
        <span :style="{color: getColor }">
            {{ mapRow('count') }}/{{ mapRow('total') }} ({{ mapRow('percent') }}%)
        </span>
    </div>
</template>

<script>

import ValueChecker from "../../services/ValueChecker";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        getColor() {
            let colorFromData = this.getColorFromData();

            if (!ValueChecker.isUndefinedOrNull(colorFromData)) {
                return colorFromData;
            }

            return this.mapRow('count') === 0 ? this.config.color : ''
        },
    },
    mounted() {
    },
    methods: {
        getColorFromData() {
            return this.mapRow('color');
        },
        mapRow(value) {
            let columnIndex = this.column.data;

            return this.row[`${columnIndex}_${value}`];
        },
    }
}
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// TotalCountComponent.vue?9daf580a